import { useState, useEffect } from 'react';

export const DEVICE_DESKTOP = 'desktop';
export const DEVICE_PAD = 'pad';
export const DEVICE_MOBILE = 'mobile';

const UseDevice = () => {
  const [device, setDevice] = useState('desktop');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024 && device !== 'desktop') {
        setDevice(DEVICE_DESKTOP);
      } else if (window.innerWidth <= 1024 && window.innerWidth > 768 && device !== 'pad') {
        setDevice(DEVICE_PAD);
      } else if (window.innerWidth <= 768 && device !== 'mobile') {
        setDevice(DEVICE_MOBILE);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [device]);

  return device;
};

export default UseDevice;
